export default import.meta.ROLLUP_FILE_URL_uwlzwyz9B1JDA1NXIl7hCw;